/**
 * Typ planu finansowego
 *
 * @export
 * @enum {number}
 */
export enum FinancialPlanType {
  FINANCIAL_UNIT = 'FINANCIAL_UNIT',
  JO = 'JO',
  /**
   * @deprecated
   */
  ORGANIZATION_UNIT = 'ORGANIZATION_UNIT',
  OW = 'OW',
  /**
   * @deprecated
   */
  TOTAL = 'TOTAL'
}

/**
 * Opcje typów raportów
 * @type {*}
 */
export const FINANCIAL_PLAN_TYPES = [
  { value: FinancialPlanType.FINANCIAL_UNIT, text: 'Razem' },
  { value: FinancialPlanType.OW, text: 'OW' },
  { value: FinancialPlanType.JO, text: 'JO prowadzone' }
];

export const FINANCIAL_PLAN_TYPE_DEFAULT = FinancialPlanType.FINANCIAL_UNIT;
